// extracted by mini-css-extract-plugin
export default {"currency":"AmountInputField_currency--kDP","hideArrows":"AmountInputField_hideArrows--AWr"};